import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

const RowContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;

  ${props => props.noFlex && css`
    flex: none !important;
  `}
`;

class RowComponent extends Component {

    constructor(props) {
      super(props)
    }

    render() {
      return (
        <RowContainer {...this.props} className={this.props.printBreak ? 'print-page-break-after' : ''}>
          {this.props.children}
        </RowContainer>
      );

    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        reduxData: state.data
    };
}

export default connect(mapStateToProps)(RowComponent);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/RowComponent.js